<template>
<div class="jumbotron jumbotron-fluid text-white d-flex mb-0" id="calculator-navigation">
    <div class="container-fluid my-auto text-center mb-0">
      <h1 class="" style="font-size: 39px; font-weight: 500;">Peterbilt Operating Costs Calculator</h1>
      <h2 class="text-white" style="font-size: 16px; font-weight: 500;">Make an informed decision between diesel and electric.</h2>
    </div>
  </div>

<div class="calculator-header py-3">
  <div class="container-fluid text-white position-relative">
    <div class="row">
      <div class="col-sm-12 text-left d-flex align-items-center">
        <button class="btn text-white heading-2 mb-0" data-toggle="collapse" data-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne" @click="trackMobileOpen()">Vehicle Configuration <span class="material-icons">add</span>
        </button>
      </div>
    </div>
    <div id="collapseOne" class="collapse collapse-selections">
      <div class="collapse-body">
        <div class="selections">
          <div class="selection-lineup" id="powertrain">
            
            <p>Powertrain:</p>
            <div class="selection-toggle">
              
              <!-- fuel-cost route -->
              <p id="fuel-cost" class="fuel-switch-toggle">
                <router-link to="/diesel/fuel-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('diesel')">
                  <span class="diesel border-right px-3">Diesel</span>
                </router-link>
                <router-link to="/electric/fuel-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('electric')">
                  <span class="electric px-3">Electric</span>
                </router-link>
              </p>

              <!-- equipment-cost route -->
              <p id="equipment-cost" class="fuel-switch-toggle">
                <router-link to="/diesel/equipment-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('diesel')">
                  <span class="diesel border-right px-3">Diesel</span>
                </router-link>
                <router-link to="/electric/equipment-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('electric')">
                  <span class="electric px-3">Electric</span>
                </router-link>
              </p>

              <!-- other-cost-route -->
              <p id="other-cost" class="fuel-switch-toggle">
                <router-link to="/diesel/other-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('diesel')">
                  <span class="diesel border-right px-3">Diesel</span>
                </router-link>
                <router-link to="/electric/other-costs" class="router-link-active router-link-exact-active fixer" @click="updateActiveFuelType('electric')">
                  <span class="electric px-3">Electric</span>
                </router-link>
              </p>

            </div>
          </div>

          <div class="selection-lineup" id="vehicle-selection">
            <p>Vehicle Selection:</p>
            <button class="btn" @click="toggleVehicleSelect">
              Select Now <img :src="`${imagePath}/arrow-down.png`" alt="">
            </button>
          </div>

          <div class="selection-lineup" id="usage-output">
            <p>Useage Output:</p>
            <p class="selection-toggle">
              <span class="border-right px-3" :class="{ active: currentUsage == 'miles' }" id="miles" @click="emitUsage('miles'); trackUsage('miles')">Miles</span>
              <span class="px-3" :class="{ active: currentUsage == 'hours' }" id="hours" @click="emitUsage('hours'); trackUsage('hours')">Hours</span>
            </p> 
          </div>

          <div class="selection-lineup">
            <p>Currency:</p>
            <p class="selection-toggle">
              <span class="border-right px-3" :class="{ active: currentCurrency == 'america' }" id="currency-us" @click="switchCurrencyToUs()">US</span>
              <span class="px-3" :class="{ active: currentCurrency == 'canada' }" id="currency-can" @click="switchCurrencyToCa()">CAN</span>
            </p>
          </div>
            
          <button class="btn btn-outline-primary text-white btn-reset" @click="resetCalculator">RESET <span class="material-icons">cached</span></button>
        </div>
      </div>
    </div>
  </div>

  <div class="vehicle-select-menu" v-if="menuActive">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 vehicle-select-container">
          <div class="vehicle-select-item" :class="[ vehicle[fuelType].name == currentVehicle.name ? 'active' : '' ]" v-for="vehicle in vehicleList" :key="vehicle" @click.prevent="switchVehicle(vehicle)">
            <img :src="vehicle[fuelType].icon" :alt="vehicle[fuelType].name + ' - Card Image'">
            <p class="fuel-type-heading">Peterbilt {{ vehicle[fuelType].name }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


</template>

<script>
  import vehicleList from '../services/vehicleList'

  export default {
    name: 'VehicleConfigurationNav',
    data() {
      return {
        vehicleList: vehicleList,
        activeVehicles: [],
        fuelType: '',
        currentVehicle: {},
        currentUsage: 'miles',
        currentCurrency: 'america',
        menuActive: false,
        imagePath: process.env.VUE_APP_ASSET_LOCATION
      }
    },
    emits: ['usage', 'currency'],
    mounted(){

      // Set current active usage based on session storage
      (sessionStorage.getItem('usage') == null || sessionStorage.getItem('usage').length === 0) ? this.currentUsage = this.currentUsage : this.currentUsage = sessionStorage.getItem('usage');
      this.emitUsage(this.currentUsage);

      // sets currency. also respect the semi colon
      (sessionStorage.getItem('currency') == null || sessionStorage.getItem('currency').length === 0) ? this.currentCurrency = this.currentCurrency : this.currentCurrency = sessionStorage.getItem('currency');
      this.emitCurrency(this.currentCurrency);

      // Pull in active vehicle to check what fuel type is
      this.fuelType = localStorage.getItem('activeFuelType');
      this.currentVehicle = this.fuelType == 'electric' ? JSON.parse(localStorage.getItem('calculatorVehicleElectric')) : JSON.parse(localStorage.getItem('calculatorVehicleDiesel'));
      
      $('#powertrain span').removeClass('active');
      if(window.location.href.indexOf('/electric/') > -1){
        $('#powertrain .electric').addClass('active');
      } else {
        $('#powertrain .diesel').addClass('active');
      }

      // for the diesel to electric transitions
      // todo ideally this would be handled in the router
      if(window.location.href.indexOf('/fuel-costs') > -1) {
        $('.fuel-switch-toggle').hide();
        $('#fuel-cost').show();
      } else if(window.location.href.indexOf('/equipment-costs') > -1) {
        $('.fuel-switch-toggle').hide();
        $('#equipment-cost').show();
      } else {
        $('.fuel-switch-toggle').hide();
        $('#other-cost').show();
      }

      

    },
    methods: {
      emitUsage(use) {
        sessionStorage.setItem('usage', use)
        this.$emit('usage', use)
        this.currentUsage = sessionStorage.getItem('usage')
        $('.collapse-selections').collapse('hide')
      },
      trackUsage(use) {
        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Configuration Usage',
          'event_label': use + ' - ' + this.$route.path
        })
      },
      trackMobileOpen() {
        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Configuration Mobile Open',
          'event_label': this.$route.path
        })
      },
      emitCurrency(currency) {
        sessionStorage.setItem('currency', currency)
        this.$emit('currency', currency)
        this.currentCurrency = sessionStorage.getItem('currency')
        $('.collapse-selections').collapse('hide')
      },
      emitCurrencyTracked(value) {
        sessionStorage.setItem('fromCanada', value)
      },
      updateActiveFuelType(fuelType) {
        localStorage.setItem('activeFuelType', fuelType)

        // Tracking
        window.gtag('event', 'Vehicle Configuration - Powertrain', {
          'event_category': 'Cost Calculator - Configuration Powertrain',
          'event_label': fuelType + ' - ' + this.$route.path
        })
      },
      resetCalculator() {
        sessionStorage.clear()
        localStorage.removeItem('calculatorVehicleElectric')
        localStorage.removeItem('calculatorVehicleDiesel')

        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Reset',
          'event_label': this.$route.path
        })

        this.$router.push({ name: 'LandingPage'})

      },
      toggleVehicleSelect() {
        this.menuActive = !this.menuActive

        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Configuration Vehicle Select Open',
          'event_label': this.$route.path
        })
      },
      switchVehicle(vehicle) {
        sessionStorage.clear()
        localStorage.setItem('calculatorVehicleElectric', JSON.stringify(vehicle['electric']))
        localStorage.setItem('calculatorVehicleDiesel', JSON.stringify(vehicle['diesel']))

        // Tracking
        window.gtag('event', 'Click', {
          'event_category': 'Cost Calculator - Configuration Vehicle Select',
          'event_label': vehicle[this.fuelType].name
        })

        if (this.$route.name == 'ElectricFuelCosts' || this.$route.name == 'DieselFuelCosts') {
          
          // if we're currently on step one, reload view with new vehicle data
          // Safari is a whiney baby when it comes to history manipulation so we have to check for it and manually reload the page if user is on Safari
          (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) ? window.location.reload() : this.$router.go()
          
        } else {
          // If we're on a different step, update vehicle data and send back to step one of corresponding fuel/vehicle
          this.fuelType == 'diesel' ? this.$router.push({name: 'DieselFuelCosts'}) : this.$router.push({name: 'ElectricFuelCosts'})
        }

        
      },
      switchCurrencyToCa() {
        
        if (sessionStorage.getItem('currency') == 'america') {

          this.emitCurrency('canada')
          this.emitCurrencyTracked(false)

          // Tracking
          window.gtag('event', 'Click', {
            'event_category': 'Cost Calculator - Configuration Currency',
            'event_label': 'CA' + ' - ' + this.$route.name
          })

          this.$router.go()

        }
      },
      switchCurrencyToUs() {
        if (sessionStorage.getItem('currency') == 'canada') {

          this.emitCurrency('america')
          this.emitCurrencyTracked(true)

          // Tracking
          window.gtag('event', 'Click', {
            'event_category': 'Cost Calculator - Configuration Currency',
            'event_label': 'US' + ' - ' + this.$route.name
          })

          this.$router.go()

        }
      }
    },
  }
</script>

<style lang="scss" scoped>
.fuel-switch-toggle {
  display: none;
}
.router-link-active, 
.router-link-exact-active,
.fixer {
  color: inherit;
  text-decoration: inherit;
}
</style>